var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2179 6.0808C19.6229 4.96049 18.5373 3.87486 17.417 4.2808L3.72482 9.23268C2.60075 9.63955 2.46482 11.1733 3.49888 11.7724L7.8695 14.3027L11.7723 10.3999C11.9491 10.2291 12.1859 10.1346 12.4318 10.1367C12.6776 10.1389 12.9127 10.2375 13.0865 10.4113C13.2603 10.5851 13.3589 10.8202 13.3611 11.066C13.3632 11.3119 13.2687 11.5487 13.0979 11.7255L9.19513 15.6283L11.7264 19.9989C12.3245 21.033 13.8583 20.8961 14.2651 19.773L19.2179 6.0808Z",
    fill: "#F6FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompose);
export default __webpack_public_path__ + "static/media/Compose.d082260d1eb732d936c664800d7d4a4c.svg";
export { ForwardRef as ReactComponent };